var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.58 33.5a2 2 0 0 0 -2-2h-12.09a14.8 14.8 0 1 0 -15.91-.5c-8.25 2.38-14.86 9.42-17 18.74a6.67 6.67 0 0 0 1.3 5.65 6.82 6.82 0 0 0 5.35 2.61h38.37a1.91 1.91 0 0 0 1.63-.9 2 2 0 0 0 .35-1.1zm-4 20.5h-12v-18.5h12zm-17.67-24.39a10.82 10.82 0 0 1 -9.68-6 1.9 1.9 0 0 0 .75-.25l8.64-5 9.81 3.51a2.06 2.06 0 0 0 .81.11 10.82 10.82 0 0 1 -10.33 7.63zm10.77-11.56-6.51-2.32 4.13-2.39a2 2 0 0 0 .6-.53 10.76 10.76 0 0 1 1.78 5.24zm-10.77-10.05a10.72 10.72 0 0 1 6.22 2l-6.9 4-7.17-2.57a10.75 10.75 0 0 1 7.85-3.43zm-10 6.71a2 2 0 0 0 .69.42l4.08 1.46-5.53 3.2c0-.32 0-.65 0-1a10.74 10.74 0 0 1 .76-4.09zm-10.91 38.23a2.67 2.67 0 0 1 -.53-2.27c2.24-9.67 10.16-16.51 19.28-16.51.69 0 1.76.06 3.19.18.26 0 .46 0 .64.07v19.59h-20.35a2.82 2.82 0 0 1 -2.23-1.06z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    rx: 2,
    width: 6,
    x: 41.75,
    y: 39.69
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.75 50.46h2a2 2 0 0 0 0-4h-2a2 2 0 0 0 0 4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/patients.e18c73eb.svg";
export { ForwardRef as ReactComponent };